import { Component, Output, EventEmitter } from '@angular/core';
import { Indication } from '../../interfaces/indication.model';
import { IndicationProvider } from '../../providers/indication/indication';
import { FilterProvider } from '../../providers/filter/filter';

@Component({
  selector: 'indication-filter',
  templateUrl: 'indication-filter.html'
})
export class IndicationFilterComponent {

  indications: Indication[];
  selectedIndication: number;
  @Output() changed: EventEmitter<any> = new EventEmitter();

  constructor(public indicationService: IndicationProvider, public filterService: FilterProvider) {
    this.indicationService.getIndications()
    .then((indications: Indication[]) => {
      this.indications = indications;
    });

    this.indicationService.currentIndication.subscribe(selectedIndication => this.selectedIndication = selectedIndication);
  }

  indicationChanged(indicationId){
    this.indicationService.setSelectedIndication(indicationId).then(() => {
      this.filterService.filterAssets().then(() => this.changed.emit(null));
    });
  }

}



// WEBPACK FOOTER //
// ./src/components/indication-filter/indication-filter.ts